import React, { useEffect, useState  , useContext} from "react";
import { Paper, Grid, Typography, Box, TextField, MenuItem , CircularProgress } from "@mui/material";
import ApiService from "../../functions/apiService";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";

const Notifications = () => {
  const [listType, setListType] = useState('All')
  const [loading , setLoading] = useState(false)
  const [notificationData , setNotificationData] = useState([])
  const navigate = useNavigate()
  const [selectedCategory, setSelectedCategory] = useState(0); 
  const [allNotificationData, setAllNotificationData] = useState([]);
	const { pages } = useContext(AuthContext);

  const loadNotifications = () => {
      setLoading(true)
      ApiService.get(`/getUserNotifications?Notification_Group_Id=${selectedCategory}&Type=${listType}`)
        .then(({ data }) => {
          const notifications = data?.data || [];
          if (listType === 'All') {
            setAllNotificationData(notifications); 
          }
          setNotificationData(notifications);
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })
  }

  useEffect(()=>{
    loadNotifications()
  }, [selectedCategory , listType])

  const formatNotificationTime = (createTime) => {
    const now = moment();
    const created = moment(createTime);
    const isToday = now.isSame(created, 'day');
    const diffInHours = now.diff(created, 'hours');
		if (isToday && diffInHours < 24) {
			let tempCreated = moment(created).format('MM/DD/YYYY HH:mm:ss')
			let givenTimeUTC = moment.utc(tempCreated, 'MM/DD/YYYY HH:mm:ss');
			// return `Today at ${givenTimeUTC.tz('America/New_York').format('hh:mm A')}`;
			return `Today at ${tempCreated}`;
    } else {
      return `${created.format('MM/DD/YYYY')}`;
    } 
  };

  const ReadNotifications = (item) => {
    const created = moment(item.Create_Time);
    ApiService.get(`/readNotification/${item.Notification_Id}`)
      .then(() => {
        if(item.Notification_Group_Id == 1 && pages.includes('V3_CERTIFICATE_MODULE')){
          navigate(`/firehouse/certificate-members/${item?.Certificate_id}`)
				}
				else if (item.Notification_Group_Id == 6 && pages.includes('V3_NEW_FILL_STRUCTURE')) {
					navigate(`/firehouse/my-shift-calls`)
				}
        else{
          navigate(`/firehouse/schedule?date=${created.format('YYYY-MM-DD')}`)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <>
      <Paper className="p-3 font-fam" style={{ marginTop: "1rem", minHeight: '98%' }}>
        <Grid container className='align-items-center' gap={2} style={{ gap: "24px", marginTop: "7px" }} >
          <Grid container className='align-items-center' gap={2} style={{ gap: "24px", marginTop: "7px", marginLeft: "7px" }} >
            <Grid item xs={10} md={3}>
              <Typography variant="h5">Notification</Typography>
            </Grid>

            <Grid container item md={4} gap={2}>
              <Grid item xs={6} sm={6} md={4}>
                <div className={listType == 'All' ? 'tab-active' : 'tab-white'}
                  onClick={() => setListType('All')}>
                  {`All (${allNotificationData.length})`}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={5}>
                <div className={listType == 'Unread' ? 'tab-active' : 'tab-white'}
                  onClick={() => setListType('Unread')}>
                  {`Unread (${notificationData.filter(n => n.Is_Read === 0).length})`}
                </div>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={4} className="d-flex justify-content-end">
              <TextField
                select size='small'
                placeholder='Category'
                className='mt-0 w-50' color='secondary' variant="outlined"
                label='Category'
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                InputProps={{
                  sx: {
                    height: '48px',
                    fontSize: '14px'
                  }
                }}
                InputLabelProps={{
                  sx: {
                    marginTop: '4px',
                    fontSize: '14px'
                  },
                }}
              >
                <MenuItem value={"0"} key={"0"} className='font-fam'>{"All"} </MenuItem>
                <MenuItem value={"1"} key={"1"} className='font-fam'>{"Certificates"} </MenuItem>
                <MenuItem value={"2"} key={"2"} className='font-fam'>{"Schedule"} </MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </Grid>

        {loading &&
          <div className='d-flex align-items-center justify-content-center mt-5'>
              <CircularProgress />
          </div>
        }

        {notificationData?.length === 0 && !loading && 
          <Box>
            <div className='mt-2 mx-2' style={{ color: '#555555' }}>
              <p>{listType == 'Unread' ? 'There are currently no Unread notifications' : 'There are currently no notifications.'}</p>
            </div>

            <div className='inner-box d-flex flex-column align-items-center justify-content-center' style={{ height: 500 }}>
              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
            </div>
          </Box>
        }

        {notificationData?.length > 0 && !loading &&
          <div style={{ width: '100%', marginTop: '30px' }} className="px-3">
            {notificationData?.map((item) => (
                <Box
                  sx={{
                    display: 'grid',
                    backgroundColor: item.Is_Read === 0 ? 'rgba(230, 91, 105, 0.1)' : '#ffffff',
                    border: item.Is_Read === 0 ? '1px solid rgba(191, 29, 45, 0.2)' : '1px solid #cccccc',
                    borderRadius:'8px',
                    marginBottom:'10px',
                    transition: 'box-shadow 0.1s ease', 
                      '&:hover': {
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.08)',
                      },
                  }}
                >
                  <Grid container spacing={2} alignItems="center" className="p-3">
                    <Grid item md={10.5} sm={10.5} style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ borderRadius: '50%', backgroundColor: item?.Is_Read === 0 ? '#BF1D2D' : '#cccccc', height: '14px', width: '14px', marginRight: '16px' , flexShrink: 0, }}></div>
                      <div>
                        <p style={{ margin: 0 , color:item.Is_Read === 0 ? '#000000' : '#333333' }}>
                          {item.Description.replace(
														/\d{4}-\d{2}-\d{2}/,
														(match) => moment(match).format("MM/DD/YYYY")
													)}
                        </p>
                        <p style={{ margin: 0 , fontSize:'12px' , color: '#555555' , paddingTop:'3px'}}>
                          {formatNotificationTime(item.Create_Time)}
                        </p>
                      </div>
                    </Grid>
                    <Grid item md={1.5} sm={1.5}>
                      <div style={{marginLeft:'16px'}}>
                        {item?.Notification_Group_Id == 1 ? 
                          <img src="/images/certificate-new.png" width={'24'} height={'24'} className="mx-3" style={{cursor:'pointer'}} onClick={() => ReadNotifications(item)}/>
                          : 
                          <img src="/images/schedule.png" width={'24'} height={'24'} className="mx-3" style={{cursor:'pointer'}} onClick={() => ReadNotifications(item)}/>
                        }
                        
                        <img src="/images/right-arrow-icon.png" width={'24'} height={'24'}  style={{cursor:'pointer'}}
                          onClick={() => ReadNotifications(item)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Box>
            ))} 
          </div>
        }

      </Paper>
    </>
  )
}

export default Notifications;